<template>
  <DropDownMultiSelectSearch
    :darkenWhenActive="darkenWhenActive"
    :multiselect="false"
    :name="itemTypeName"
    :options="options"
    :showFullValueText="true"
    :value="[value]"
    @input="handleInput"
    @open="handleOpenEvent"
  />
</template>

<script>
import DropDownMultiSelectSearch from 'client/components/DropDownMenu/DropDownMultiSelectSearch/DropDownMultiSelectSearch.vue';

/**
 * To help with the case where we need to use the single select configuration
 * of DropDownMultiSelectSearch in forms so that the style is consistent.
 */
export default {
  name: 'DropDownSelect',

  components: {
    DropDownMultiSelectSearch,
  },

  props: {
    darkenWhenActive: {
      type: Boolean,
      default: false,
    },
    itemTypeName: {
      type: String,
      default: undefined,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: undefined,
    },
  },

  methods: {
    handleInput(newValue) {
      this.$emit('input', newValue[0]);
    },

    handleOpenEvent() {
      this.$emit('open', this.value);
    },
  },
};
</script>
